import {
    Chip,
    Stack,
    Typography,
    Box,
    useTheme,
    IOption,
} from '../../../../base';
export interface Props {
    options: IOption[];
    label?: string;
    value: Array<string | number>;
    onSelectionChange: (selectedOptions: Array<string | number>) => void;
}

const MultiSelectionAction = (Props: Props) => {
    const theme = useTheme();
    const { options, label, value, onSelectionChange } = Props;
    const handleChipClick = (optionClicked: string) => {
        const newValue = value.includes(optionClicked)
            ? value.filter((item) => item !== optionClicked)
            : [...value, optionClicked];
        onSelectionChange(newValue);
    };

    return (
        <Box sx={{ padding: 2 }}>
            {label && (
                <Typography variant="subtitle1" gutterBottom>
                    {label}
                </Typography>
            )}
            <Stack direction="row" flexWrap="wrap">
                {options.map((option) => (
                    <Chip
                        key={option.value}
                        label={option.label}
                        onClick={() => handleChipClick(option.value)}
                        color={
                            value?.includes(option.value)
                                ? 'primary'
                                : 'default'
                        }
                        variant={
                            value?.includes(option.value)
                                ? 'filled'
                                : 'outlined'
                        }
                        sx={{ margin: theme.spacing(0.5) }}
                    />
                ))}
            </Stack>
        </Box>
    );
};

export default MultiSelectionAction;
